<script>
    import Icon from '../icon/Icon.svelte';

    export let items = []
    export let defaultValue = null
    export let label = ''
    export let placeholder = ''
    export let inline = false
    export let disabled = false
    export let callback = () => {}

    export function getValue() {
        // If selected value is not contained in the list or is the placeholder, {item: {value: undefined}} is returned.
        return {
            item: selectedItem
        }
    }

    export function setValue(value) {
        const item = items.find(item => item.value === value)
        if (item) {
            selectedItem = item
        } else if (placeholder) {
            selectedItem = {value: undefined}
        }
    }

    export function setItems(newItems) {
        items = newItems
    }

    const id = _.uniqueId()
    const isDefaultValueValid = items.some((item) => item.value === defaultValue)
    let selectedItem

    // If no value is preselected, make sure a placeholder is present
    if (!placeholder && !isDefaultValueValid) {
        placeholder = window.i18n.gettext('None')
    }

    // Set the default if given
    if (isDefaultValueValid) {
        setValue(defaultValue)
    }

    function onChange() {
        if (callback) {
            callback(selectedItem)
        }
    }
</script>

<div class="quick-select" class:inline class:disabled>
    {#if label}
        <label for={id} class="label">{label}</label>
    {/if}
    <div class="select-container" component="quick-select-select-container">
        <select
            {id}
            bind:value={selectedItem}
            on:change={onChange}
            {disabled}
            title={selectedItem?.label}
        >
            {#if placeholder}
                <option value={{value: undefined}} disabled="true" selected={!isDefaultValueValid}>
                    {placeholder}
                </option>
            {/if}
            {#each items as item}
                <option value={item} disabled={item.disabled} selected={item.selected}>{item.label}</option>
            {/each}
        </select>
        <div class="value" inert>
            {selectedItem?.label || placeholder || ''}
        </div>
        <div class="arrow" inert>
            <Icon name="arrow-down"></Icon>
        </div>
    </div>
</div>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.quick-select {
  display: flex;
  flex-direction: column;
}
.quick-select.inline {
  display: inline-flex;
  align-items: flex-start;
}
.quick-select.disabled {
  opacity: 0.8;
}
.quick-select .label {
  font-size: 14px;
  font-variant-caps: all-small-caps;
  letter-spacing: 1px;
  line-height: 12px;
  color: hsl(205, 60%, 44%);
  margin-bottom: 8px;
}
.quick-select .select-container {
  border-radius: 16px;
  padding: 14px 16px;
  border: solid 1px hsl(40, 4%, 84%);
  background-color: #fff;
  font-size: 16px;
}
.quick-select .select-container:focus-within {
  border-color: hsl(205, 60%, 44%);
  outline: none;
}
.quick-select .select-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 14px;
}
.quick-select .select-container select {
  position: absolute;
  inset: 0;
  padding-left: 8px;
  padding-right: 8px;
  opacity: 0;
  appearance: none;
  cursor: pointer;
}
.quick-select .select-container select:disabled {
  cursor: not-allowed;
}
.quick-select .select-container .value {
  min-width: 40px;
}
.quick-select .select-container .arrow {
  display: flex;
  width: 16px;
  height: 16px;
  fill: currentColor;
}</style>
